// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error{padding-top:1.7142857143rem;padding-bottom:0.5714285714rem}`, "",{"version":3,"sources":["webpack://./altaLoginApp/components/ErrorAlert/ErrorAlert.scss"],"names":[],"mappings":"AAEA,OACE,2BAAA,CACA,8BAAA","sourcesContent":["@use 'assets/scss/common';\n\n.error {\n  padding-top: common.toRem(24);\n  padding-bottom: common.toRem(8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
